import _ from 'lodash';
import {PREFIX, actionMeta} from './meta';
import URLService from 'service/URLService';

const ty = actionMeta.identifiers;

let initState = {
  users: null
};

export default function reducer(state = initState, action = "") {

  if (action.type.startsWith(PREFIX)) {
    switch (action.type) {
      case ty.USERS_LIST_REQUEST:
        state = {
          ...state,
          users: null
        }
        break;
      case ty.USERS_LIST_RESPONSE:
        state = {
          ...state,
          users: action.payload.data.users
        }
        break;
      case ty.USER_CREATE_RESPONSE:
        state = {
          ...state,
          users: [
            ..._.filter(state.users, (t) => t.id!=action.payload.data.id),
            action.payload.data
          ]
        }
        URLService.setQueryParameter("user_id", action.payload.data.id)
        break;
      default:
        return state
        break;
    }
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/storeState/users/reducer.js